import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { SafetyDesktopRouter } from "./common/routers/SafetyDesktopRouter"
import { SafetyMobileRouter } from "./common/routers/SafetyMobileRouter/SafetyMobileRouter"
import { RiskZonesContextProvider } from "./modules/riskZones/contexts/RiskZonesContext"
import { SpeedingsContextProvider } from "./modules/speedings/contexts/SpeedingsContext"

export function L2rAppSafety() {
    const isMobile = useIsMobileDevice()

    return (
        <RiskZonesContextProvider>
            <SpeedingsContextProvider>
                {
                    isMobile ? <SafetyMobileRouter /> : <SafetyDesktopRouter />
                }
            </SpeedingsContextProvider>
        </RiskZonesContextProvider>
    )
}
